import {Deserializable} from '../deserializable';
import {Staffs} from '../staff/staffs';
import {VanBanDenFile} from './vanbandenfile';
import {VanBanDenFileXL} from './vanbandenfilexl';
export  class VanBanDenComment implements Deserializable
{
  public  id: number;
  public  maXLId: number;
  public  comment: string;
  public  staffId: number;
  public  created: string;
  public  staffs:  Staffs;
  public status: number;
  public soLanDoc: number;
  public thoiGianXem: string;
  public thoiGianXemLanDau: string;
  public capXuLy: number;
  public maChuTri: number;
  public nguoiChuTri: Staffs;
  public vanBanDenXLFiles: VanBanDenFileXL[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.staffs = input.staffs != null ? new Staffs().deserialize(input.staffs): null;
    this.nguoiChuTri = input.nguoiChuTri != null ? new Staffs().deserialize(input.nguoiChuTri): null;
    this.vanBanDenXLFiles = input.vanBanDenXLFiles != null ? input.vanBanDenXLFiles.map(vanBanDenXLFiles => new VanBanDenFileXL().deserialize(vanBanDenXLFiles)): [];
    return this;
  }
}
